import React, { useState, useEffect } from 'react'
import {
	Row,
	Col,
	Button,
	Form,
	Nav,
	Alert,
	Image
} from 'react-bootstrap'
import styles from './UpdateUser.module.scss'
import { Formik, Form as FormikForm } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import Toast from '../../components/toasts/Toast'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

interface DataProps {
	id: number
	name: string
}
interface VcfKioskType {
	id: number
	label: string
	type: string
}
const UpdateUser = () => {
	const [inputs, setInputs] = useState({
		name: '',
		contact: '',
		email: '',
		isActive: false
	})
	const [services, setServices] = useState({
		MICROSITE: [],
		VCF: [],
		KIOSK: []
	})
	const param = useParams()
	const adminId = param.id !== undefined ? parseInt(param.id) : ''
	const { t } = useTranslation()

	//selected services
	const [selectedMicrosite, setSelectedMicrosite] = useState<string[]>([])
	const [selectedVCF, setSelectedVCF] = useState<string[]>([])
	const [selectedKIOSK, setSelectedKIOSK] = useState<string[]>([])

	//success / error messsages
	const [emptySelect, setEmptySelect] = useState(false)
	const [updateSuccess, setUpdateSuccess] = useState(false)
	const [updateFailed, setUpdateFailed] = useState(false)

	//validation
	const validationSchema = Yup.object().shape({
		name: Yup.string().min(2, t('Too_short')).max(50, t('Too_Long')).required(t('required.field')),
		contact: Yup.number().min(8, t('At_least_8_number')).typeError(t('This_must_be_a_number'))
	})

	//event handlers
	const handleClick = (e: React.ChangeEvent<HTMLInputElement>, type: string): void => {
		const name = e.target.name
		if (type === 'microsite') {
			const tempArr = Array.from(selectedMicrosite)
			//checkbox on or off
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedMicrosite(unCheck)
			} else {
				setSelectedMicrosite(arr => [...arr, name])
			}
		}

		if (type === 'VCF') {
			const tempArr = Array.from(selectedVCF)
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedVCF(unCheck)
			} else {
				setSelectedVCF(arr => [...arr, name])
			}
		}

		if (type === 'KIOSK') {
			const tempArr = Array.from(selectedKIOSK)
			if (tempArr.includes(name)) {
				const unCheck = tempArr.filter(ele => ele !== name)
				setSelectedKIOSK(unCheck)
			} else {
				setSelectedKIOSK(arr => [...arr, name])
			}
		}

		setEmptySelect(false)

	}

	const handleSubmit = async (values: { name: string; contact: string; email: string; }) => {
		//format to MICROSITE_SOUTHEAST,MICROSITE_NTUC,VCF_1,VCF_2,KIOSK_1
		const formatMicrosite = selectedMicrosite.map((ele) => { return 'MICROSITE_' + ele })
		const formatVCF = selectedVCF.map((ele) => { return 'VCF_' + ele })
		const formatKIOSK = selectedKIOSK.map((ele) => { return 'KIOSK_' + ele })
		const combinedServices = formatMicrosite.concat(formatVCF).concat(formatKIOSK)

		if (!combinedServices.length) {
			setEmptySelect(true)
			return
		}
		try {
			const updateData = {
				name: values.name,
				contact: values.contact,
				email: values.email,
				isActive: inputs.isActive
			}
			const updateServicesData = {
				id: adminId,
				services: combinedServices.toString()
			}

			const res = await axios.put(process.env.REACT_APP_ROUTE_UPDATE_ADMIN + '/' + adminId as string, updateData)
			await axios.post(process.env.REACT_APP_ROUTE_UPDATE_USER_SERVICES as string, updateServicesData)
			if (res.data.updated) {
				const obj = {
					id: adminId,
					name: res.data.name
				}
				localStorage.setItem('E2ICurrentUser', JSON.stringify(obj))
				setUpdateSuccess(true)
				setUpdateFailed(false)
				//window.location.reload()
			} else {
				setUpdateSuccess(false)
				setUpdateFailed(true)
			}
		} catch (err) {
			setUpdateSuccess(false)
			setUpdateFailed(true)
			return console.log(err)
		}
	}

	//on page load
	useEffect(() => {
		const getUserProfile = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_CRUD_PROFILE as string + '/' + adminId)
				const { user } = res.data
				const userServices = res.data.user[0].E2I_User_Services
				const allServices = await axios.get(process.env.REACT_APP_ROUTE_GET_ALL_SERVICES as string)
				setInputs({
					...inputs,
					name: user[0].name ?? '',
					contact: user[0].contact ?? '',
					email: user[0].email,
					isActive: user[0].isActive
				})
				setServices({
					MICROSITE: allServices.data.MICROSITE.map((ele: string) => {
						return { name: ele, label: ele, type: 'MICROSITE' }
					}),
					VCF: allServices.data.VCF.map((ele: DataProps) => {
						return { id: ele.id, label: ele.name, type: 'VCF' }
					}),
					KIOSK: allServices.data.KIOSK.map((ele: DataProps) => {
						return { id: ele.id, label: ele.name, type: 'KIOSK' }
					})
				})
				const userMicrosites = userServices.filter((ele: { type: string }) => ele.type === 'MICROSITE').map((ele: { name: string }) => ele.name)
				const userVCF = userServices.filter((ele: { type: string }) => ele.type === 'VCF').map((ele: { name: string }) => ele.name)
				const userKiosk = userServices.filter((ele: { type: string }) => ele.type === 'KIOSK').map((ele: { name: string }) => ele.name)
				setSelectedMicrosite(userMicrosites)
				setSelectedVCF(userVCF)
				setSelectedKIOSK(userKiosk)
			} catch (err) {
				return console.log(err)
			}
		}
		getUserProfile()
	}, [])

	return (
		<div>
			<Row className={styles.searchCompRow}>
				{/* hide breadcrumb on xs */}
				<Col className="d-none d-sm-block">
					<Nav className={styles.breadCrumb}>
						<Nav.Item>
							<Nav.Link href="/manage-users" style={{ paddingLeft: '0px' }}>Manage Users</Nav.Link>
						</Nav.Item>
						<div className={styles.dateArrow}>
							<FontAwesomeIcon icon={faChevronRight} size="xs" color="#5B7493" />
						</div>
						<Nav.Item>
							<Nav.Link style={{ textDecoration: 'underline', color: '#233953' }}>Update Profile</Nav.Link>
						</Nav.Item>
					</Nav>
				</Col>
			</Row>
			<Formik
				enableReinitialize
				initialValues={inputs}
				validationSchema={validationSchema}
				onSubmit={values => {
					handleSubmit(values)
				}}
			>
				{({ values, handleChange, errors, touched }) => (
					<FormikForm>
						<Row>
							<Col>
								<Form.Group className='mb-4 mt-5'>
									<Col>
										<Form.Label>Name</Form.Label>
										<Form.Control
											className={styles.formControl}
											type='text'
											placeholder={t('profile_personal.enter_name')}
											name='name'
											value={values.name}
											onChange={handleChange}
										/>
										{errors.name && touched.name && <div className={styles.errMessage}
										>{errors.name}</div>}
									</Col>
								</Form.Group>

								<Form.Group className='mb-3'>
									<Col>
										<Form.Label>Contact Number</Form.Label>
										<Form.Control
											className={styles.formControl}
											placeholder='Enter your contact number'
											name='contact'
											value={values.contact}
											onChange={handleChange}
											minLength={8} maxLength={8}
										/>
										{errors.contact && touched.contact && <div className={styles.errMessage}
										>{errors.contact}</div>}
									</Col>
								</Form.Group>

								<Form.Group className='mb-3'>
									<Col>
										<Form.Label>{t('profile.email')}</Form.Label>
										<span className={styles.mandatory}>*</span>
										<Form.Control
											className={styles.formControl}
											type='email'
											placeholder={t('sign_up.email_plhlder')}
											name='email'
											value={values.email}
											onChange={handleChange}
											required
										/>
										{errors.email && touched.email && <div className={styles.errMessage}
										>{errors.email}</div>}
									</Col>
								</Form.Group>

								<Form.Group className='mb-5'>
									<Col>
										<Form.Label>Admin&apos;s active status</Form.Label>
										<span className={styles.mandatory}>*</span>
										<Form.Check
											type='switch'
											id="custom-switch"
											className={styles.form__switch}
											onChange={() => setInputs({ ...inputs, isActive: !inputs.isActive })}
											checked={inputs.isActive}
										/>
										<small className='fst-italic d-block'>An admin who is set to inactive will not be able to log in and access the features</small>
									</Col>
								</Form.Group>
							</Col>
							<Col>
								<Form.Group className='mb-3 mt-5'>
									<Col className={styles.form__scrollable}>
										<Form.Label>Services</Form.Label>
										<span className={styles.mandatory}>*</span>

										<Row className='mb-3'>
											<Col>
												<Form.Group>
													<Form.Label>Choose which services the user is able to access</Form.Label>
												</Form.Group>

												{/* <div className='mt-1 mb-1'>
													<Image src='/img/briefcase.png' alt='se' width='20' height='17' />
													<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Microsites</span>
												</div>
												<Form.Check className="mb-1">
													<Form.Check.Input
														style={{ border: '1px solid #DEE7F2' }}
														type="checkbox"
														name="NTUC"
														id="NTUC"
														onChange={(e) => handleClick(e, 'microsite')}
														checked={selectedMicrosite.includes('NTUC')}
													/>
													<Form.Check.Label htmlFor='NTUC' style={{ paddingLeft: '13px' }}>LMUnited</Form.Check.Label>
												</Form.Check>
												<Form.Check className="mb-1">
													<Form.Check.Input
														style={{ border: '1px solid #DEE7F2' }}
														type="checkbox"
														name="SOUTHEAST"
														id="SOUTHEAST"
														onChange={(e) => handleClick(e, 'microsite')}
														checked={selectedMicrosite.includes('SOUTHEAST')}
													/>
													<Form.Check.Label htmlFor="SOUTHEAST" style={{ paddingLeft: '13px' }}>Jobs @ SouthEast</Form.Check.Label>
												</Form.Check>
												<div className='mt-3 mb-1'>
													<Image src='/img/VCFIcon.png' alt='VCFIcon' width='20' height='17' />
													<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Virtual Career Fairs</span>
												</div>
												{services.VCF.map((ele: VcfKioskType) => {
													return (
														<Form.Check className="mb-1" key={ele.id}>
															<Form.Check.Input
																style={{ border: '1px solid #DEE7F2' }}
																type="checkbox"
																name={(ele.id).toString()}
																id={ele.label}
																onChange={(e) => handleClick(e, 'VCF')}
																checked={selectedVCF.includes((ele.id).toString())}
															/>
															<Form.Check.Label htmlFor={ele.label} style={{ paddingLeft: '13px' }}>{ele.label}</Form.Check.Label>
														</Form.Check>
													)
												})} */}
												<div className='mt-3 mb-1'>
													<Image src='/img/kiosks.png' alt='jobstations' width='15' height='23' />
													<span style={{ fontWeight: '500', paddingLeft: '18px', color: 'black' }}>Job Stations</span>
												</div>
												{services.KIOSK.map((ele: VcfKioskType) => {
													return (
														<Form.Check className="mb-1" key={ele.id}>
															<Form.Check.Input
																style={{ border: '1px solid #DEE7F2' }}
																type="checkbox"
																name={(ele.id).toString()}
																id={ele.label}
																onChange={(e) => handleClick(e, 'KIOSK')}
																checked={selectedKIOSK.includes((ele.id).toString())}
															/>
															<Form.Check.Label htmlFor={ele.label} style={{ paddingLeft: '13px' }}>{ele.label}</Form.Check.Label>
														</Form.Check>
													)
												})}
											</Col>
										</Row>

									</Col>
								</Form.Group>

							</Col>
						</Row>

						<Col md={4}>
							<Toast
								show={updateSuccess}
								setShow={setUpdateSuccess}
								position={'top-end'}
								headerText='Successful!'
								bodyText='Your profile has been updated'
								textColor='green' />
							<Toast
								show={updateFailed}
								setShow={setUpdateFailed}
								position={'top-end'}
								headerText='Unsuccessful'
								bodyText='Update failed, please try again'
								textColor='red' />
						</Col>
						<br />
						<Row>
							<Col>
								{emptySelect && <Alert variant='danger'>Services must not be empty</Alert>}

								<Row>
									<Col>
										<div className={styles.submitBtn}>
											<Link to='/manage-users'>
												<Button
													variant='link'
												>
													Back
												</Button>
											</Link>&nbsp;&nbsp;
											<Button
												className='text-white px-5'
												variant='primary'
												type='submit'
											>{t('submit')}</Button>
										</div>
									</Col>
								</Row>
							</Col>

						</Row>
					</FormikForm>
				)}
			</Formik>




		</div>
	)
}

export default UpdateUser